import { Button, EditableText, Switch } from '@blueprintjs/core'
import * as classnames from 'classnames/bind'
import * as React from 'react'

import Sortable from 'react-sortablejs'
import { dispatch } from '../../store'
import Chapter from './lecture-content-chapter'
import LectureDateSetting from './lecture-date-setting'
import TypeCheckboxGroup from './lecture-type-checkbox'

import styles from './lecture-content.scss'
import itemStyles from './lecture-item.scss'

const cx = classnames.bind({ ...styles, ...itemStyles })

interface IProps {
  isEdit: boolean
  units: IUnit[]
  lecture: ILecture
  lectureId: string
}

interface IState {
  units: IUnit[]
  isOpen?: boolean
}

class LectureContent extends React.Component<IProps> {
  public state: IState = {
    units: [],
    isOpen: false
  }
  public componentDidMount = () => {
    this.setState({ units: this.props.units })
  }
  public componentWillReceiveProps = (nextProps: IProps) => {
    this.setState({ units: nextProps.units })
  }
  public onLectureTitleChange = (title: string) => {
    const { lectureId } = this.props
    dispatch.lectures.updateLecture({
      lectureId,
      updated: { title }
    })
  }
  public addUnitSection = (units: IUnit[]) => {
    const { lectureId } = this.props

    const unit: IUnit = {
      title: `單元${units.length + 1}`,
      chapters: []
    }
    dispatch.lectures.updateLecture({
      lectureId,
      updated: { units: [...units, unit] }
    })
  }
  public addChapterSection = (units: IUnit[], id: number) => {
    const { lectureId } = this.props

    const chapter: IChapter = {
      title: `new chapter`,
      trial: false,
      insightIds: []
    }
    dispatch.lectures.updateLecture({
      lectureId,
      updated: {
        units: [
          ...units.slice(0, id),
          {
            ...units[id],
            chapters: [...units[id].chapters, chapter]
          },
          ...units.slice(id + 1)
        ]
      }
    })
  }

  public onUnitTitleChange = (title: string, id: number, units: IUnit[]) => {
    const { lectureId } = this.props

    dispatch.lectures.updateLecture({
      lectureId,
      updated: {
        units: [
          ...units.slice(0, id),
          {
            ...units[id],
            title
          },
          ...units.slice(id + 1)
        ]
      }
    })
  }

  public deleteUnit = (id: number, units: IUnit[]) => {
    const { lectureId } = this.props

    dispatch.lectures.updateLecture({
      lectureId,
      updated: {
        units: [...units.slice(0, id), ...units.slice(id + 1)]
      }
    })
  }

  public onChapterTitleChange = (
    title: string,
    id: number,
    cid: number,
    units: IUnit[]
  ) => {
    const { lectureId } = this.props
    // units[id].chapters[cid].title = title

    dispatch.lectures.updateLecture({
      lectureId,
      updated: {
        units: [
          ...units.slice(0, id),
          {
            ...units[id],
            chapters: [
              ...units[id].chapters.slice(0, cid),
              {
                ...units[id].chapters[cid],
                title
              },
              ...units[id].chapters.slice(cid + 1)
            ]
          },
          ...units.slice(id + 1)
        ]
      }
    })
  }
  public deleteChapter = (id: number, cid: number, units: IUnit[]) => {
    const { lectureId } = this.props

    dispatch.lectures.updateLecture({
      lectureId,
      updated: {
        units: [
          ...units.slice(0, id),
          {
            ...units[id],
            chapters: [
              ...units[id].chapters.slice(0, cid),
              ...units[id].chapters.slice(cid + 1)
            ]
          },
          ...units.slice(id + 1)
        ]
      }
    })
  }
  public handleSwitchChange = (
    event: React.FormEvent<HTMLInputElement>,
    id: number,
    cid: number,
    trial: boolean,
    units: IUnit[]
  ) => {
    const { lectureId } = this.props

    dispatch.lectures.updateLecture({
      lectureId,
      updated: {
        units: [
          ...units.slice(0, id),
          {
            ...units[id],
            chapters: [
              ...units[id].chapters.slice(0, cid),
              {
                ...units[id].chapters[cid],
                trial: !trial
              },
              ...units[id].chapters.slice(cid + 1)
            ]
          },
          ...units.slice(id + 1)
        ]
      }
    })
  }
  public handleClick = () => {
    this.setState({ isOpen: !this.state.isOpen })
  }
  public LectureList = (units: IUnit[]) => {
    const { isEdit, lectureId } = this.props
    return (
      <div className={cx('lecture_list')}>
        {isEdit ? (
          <React.Fragment>
            <TypeCheckboxGroup
              isEdit={true}
              lectureId={this.props.lectureId}
              tags={this.props.lecture.tags}
            />
            <LectureDateSetting
              isEdit={true}
              lectureId={this.props.lectureId}
              lecture={this.props.lecture}
            />
          </React.Fragment>
        ) : null}
        {isEdit ? (
          <div className={cx('lecture_list_header')}>
            <h3>
              建立講座章節{' '}
              <h4>
                <span>*</span>請至少設定一個可以試聽的章節
              </h4>
            </h3>
            {/* tslint:disable-next-line jsx-no-lambda */}
            <div>
              <Button
                icon="plus"
                text="單元"
                active={true}
                className={cx('lecture_list_addButton')}
                onClick={() => this.addUnitSection(units)}
              />
            </div>
          </div>
        ) : (
          <div className={cx('lecture_list_header')} />
        )}
        {isEdit ? (
          <div className={cx('lecture_list_content')}>
            {units.map((unit, id) => (
              <ul key={id}>
                <div className={cx('lecture_list_unitHeader')}>
                  <EditableText
                    defaultValue={unit.title}
                    placeholder="單元標題"
                    // tslint:disable-next-line jsx-no-lambda
                    onConfirm={(title: string) =>
                      this.onUnitTitleChange(title, id, units)
                    }
                  />
                  <div className={cx('lecture_list_unit_toolbox')}>
                    {/* tslint:disable-next-line jsx-no-lambda */}
                    <Button
                      icon="plus"
                      active={false}
                      className={cx('lecture_list_addChapterButton')}
                      onClick={() => this.addChapterSection(units, id)}
                    />
                    {/* tslint:disable-next-line jsx-no-lambda */}
                    <Button
                      icon={'trash'}
                      text=""
                      active={false}
                      className={cx('section_content_list_deleteButton')}
                      onClick={() => this.deleteUnit(id, units)}
                    />
                  </div>
                </div>
                <Sortable
                  className={cx('lecture_list_unitContainer')}
                  options={{
                    group: 'shared'
                  }}
                  tag="ul"
                  // tslint:disable-next-line jsx-no-lambda
                  onChange={(
                    order: string[],
                    sortable: React.FormEvent<HTMLInputElement>,
                    evt: React.FormEvent<HTMLInputElement>
                  ) => {
                    const { lectureId } = this.props
                    // deep clone units
                    const mockUnits = JSON.parse(JSON.stringify(units))
                    mockUnits[id].chapters = []
                    order.forEach(chapter => {
                      const idx = chapter.split('-')
                      if (parseInt(idx[0], 10) !== id) {
                        mockUnits[idx[0]].chapters.splice(idx[1], 1)
                      }
                      mockUnits[id].chapters.push(
                        units[idx[0]].chapters[idx[1]]
                      )
                    })
                    dispatch.lectures.updateLecture({
                      lectureId,
                      updated: {
                        units: mockUnits
                      }
                    })
                  }}
                >
                  {unit.chapters.map((chapter, cid) => (
                    <li
                      key={`${chapter.title}-${cid}`}
                      data-id={`${id}-${cid}`}
                    >
                      <p>{`${id + 1}-${cid + 1}`}</p>
                      <EditableText
                        defaultValue={chapter.title}
                        placeholder="章節標題"
                        className={cx('lecture_list_chapter_editText')}
                        // tslint:disable-next-line jsx-no-lambda
                        onConfirm={(title: string) =>
                          this.onChapterTitleChange(title, id, cid, units)
                        }
                      />
                      <div className={cx('lecture_list_chapter_toolbox')}>
                        <Switch
                          large={true}
                          checked={chapter.trial}
                          label="試聽"
                          // tslint:disable-next-line:jsx-no-lambda
                          onChange={(e: React.FormEvent<HTMLInputElement>) =>
                            this.handleSwitchChange(
                              e,
                              id,
                              cid,
                              chapter.trial,
                              units
                            )
                          }
                        />
                        <Button
                          icon={'trash'}
                          text=""
                          active={false}
                          className={cx('section_content_list_deleteButton')}
                          // tslint:disable-next-line:jsx-no-lambda
                          onClick={() => this.deleteChapter(id, cid, units)}
                        />
                      </div>
                    </li>
                  ))}
                </Sortable>
              </ul>
            ))}
          </div>
        ) : (
          <div className={cx('lecture_list_preview')}>
            {<Chapter lectureId={lectureId} unit={units[0]} />}
          </div>
        )}
      </div>
    )
  }
  public render() {
    const { units, isEdit } = this.props
    return (
      <div className={cx('section')}>
        <div className={cx('section_header')}>
          {isEdit ? '本次講座包含以下內容' : '本次講座包含以下內容'}
        </div>
        <div className={cx('section_content')}>{this.LectureList(units)}</div>
      </div>
    )
  }
}

export default LectureContent



// WEBPACK FOOTER //
// ./src/pages/LecturePage/lecture-content.tsx